/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Item/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Discussion from './Discussion/index'
import InApp from './InApp/index'
import No from './No/index'
import Phone from './Phone/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Item({
  children,
  viewPath = "/DesignSystem/PatientComms/PatientCommsContactMethods/Content/Item"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let contactMethodTypeValueData = fromData.useDataValue({ viewPath,
context: 'contact_method',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: contactMethodTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'InApp'}>
<InApp
  viewPath={`${viewPath}/InApp`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Phone'}>
<Phone
  viewPath={`${viewPath}/Phone`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Discussion'}>
<Discussion
  viewPath={`${viewPath}/Discussion`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}